// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pv-0";
export var animationContainer = "_pv-1";
export var itemPrice = "_pv-a";
export var itemizedContent = "_pv-9";
export var itemizedHeader = "_pv-7";
export var itemizedRow = "_pv-8";
export var itemizedSection = "_pv-6";
export var modalContent = "_pv-2";
export var orderName = "_pv-3";
export var refundOption = "_pv-4";
export var refundOptionsContainer = "_pv-5";
export var shippingLabel = "_pv-b";
export var totalRow = "_pv-c";